import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import PcRoutes from "./pc";
import MRoutes from "./m";
import { Message } from "element-ui";

let hasShownProfileTip = false; // 防止多次弹
Vue.use(VueRouter); // 修复 push 报错
import { Hc_IsMobile, checkUserProfileComplete } from "@/tools/hc";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new VueRouter({
  routes: Hc_IsMobile() ? MRoutes : PcRoutes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});
router.beforeEach(async (to, from, next) => {
  console.log("router11", to, from, Hc_IsMobile());
  // UI 状态
  store.commit("SET_MENU_NAME", to.meta.name || "");
  store.state.showbg = false;
  store.state.showLeftMenu = !!to.meta.showLeftMenu; // 分类只拉一次
  if (!store.state.book.bookCate || store.state.book.bookCate.length === 0) {
    await store.dispatch("book/fetchBookCate");
  }

  const isLogin = store.getters["user/isLogin"]; // ===== 已登录用户不能进登录 / 注册 =====
  if (to.meta.guestOnly && isLogin) {
    return next("/user/index");
  }

  // ===== 需要登录的页面 =====
  if (to.meta.requiresAuth) {
    let userInfo = store.state.user.userInfo;
    if (!isLogin) {
      try {
        await store.dispatch("user/fetchUserInfo");
        userInfo = store.state.user.userInfo;
      } catch (err) {
        return next("/login");
      }
    }
    // ✅ ===== 新增：资料完整性校验 =====
    const isComplete = checkUserProfileComplete(userInfo);
    // 当前不是完善页面，并且资料不完整
    if (!isComplete && to.path !== "/user/index" && to.path !== "/user/info") {
      if (!hasShownProfileTip) {
        Message.warning("您的资料不全，请先完善资料");
        hasShownProfileTip = true;
      }

      setTimeout(() => {
        console.log("Hc_IsMobile", Hc_IsMobile());
       next(Hc_IsMobile() ? "/user/info" : "/user/index");
        hasShownProfileTip = false; // 重置（可选）
      }, 1000);

      return; // ⚠️ 必须 return，防止 next() 被继续执行
    
    }

    return next();
  }
  // ===== 其他页面 =====
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js